import {
  ALGOLIA_DYNAMIC_RANKING,
  SEARCH_BOX_SUGGESTED_PRODUCT_CLICK,
  SERP_PRODUCT_DETAIL_CLICK,
} from 'shared/experiments/consts'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'

export default () => {
  const experiment = getExperimentOnClient(ALGOLIA_DYNAMIC_RANKING)

  if (!experiment.isEnabled) {
    return
  }

  document.addEventListener('click', (e: MouseEvent) => {
    const target = e.target as HTMLElement

    if (target.closest('[data-clientside-hook="SearchBoxListItemLink"]')) {
      trackOptimizelyEvent(SEARCH_BOX_SUGGESTED_PRODUCT_CLICK)
    }

    if (target.closest('[data-clientside-hook~="productDetailButton"]')) {
      trackOptimizelyEvent(SERP_PRODUCT_DETAIL_CLICK)
    }
  })
}
